import { FilterSingleCheckbox } from '../baseInputTypes/FilterSingleCheckbox'

type Props = {}
export const TIP = (props: Props) => {
  return <FilterSingleCheckbox label="TIP" fieldPath="productInformation.TIP" />
}
